export default __webpack_public_path__ + "4e195ab1f5a4186eac9fae351fa4edbc.png";